import { findContentElements } from './findAllContentElements';
import { getVisibleElementsWithinRectBounds } from './findCenteredElementInViewport';


export default function getVisibleContentElements({
  containerElement,
  overflowAbove = 0,
  overflowBelow = 0,
}: {
  containerElement: HTMLElement;
  overflowAbove?: number;
  overflowBelow?: number;
}): HTMLElement[] {
  const containerRect = containerElement.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  const top = -overflowAbove;
  const bottom = viewportHeight + overflowBelow;

  if (containerRect.bottom <= top || containerRect.top >= bottom) {
    return [];
  }

  const contentElements = findContentElements(containerElement, { shouldExcludeMedia: true });
  const viewportRect = { top, bottom, left: 0, right: window.innerWidth };
  return getVisibleElementsWithinRectBounds(contentElements, viewportRect);
}
